import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import { AppState } from 'src/app';
import { SessionService } from 'src/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'user-is-locked',
  templateUrl: 'userIsLocked.component.html',
  styleUrls: ['./userIsLocked.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserIsLockedComponent implements OnInit {
  private elPatronData: any = {};

  constructor(
    @Inject(DOCUMENT) private document: any,
    private sessionService: SessionService,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.store
      .select('elPatronData')
      .pipe(
        map((value: any) => value.toJS()),
        filter((value: any) => value.URL_SIGNIN !== undefined),
        take(1),
      )
      .subscribe((value: any) => {
        this.elPatronData = value;
      });
  }

  redirectToPatron() {
    let redirectTo: string;
    this.sessionService.logout(false);
    redirectTo = this.getSignOutUrl();

    this.document.location.href = redirectTo;
  }

  private getSignOutUrl() {
    return this.elPatronData.URL_SIGNOUT;
  }
}
